import { Button, Flex, ScrollArea } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';

function Form({
  onClickCancel,
  cancelText = 'Cancel',
  onClickSubmit,
  submitText = 'Save changes',
  children,
  submitDisabled = false,
}) {
  function onSubmit(e) {
    e.preventDefault();
  }

  return (
    <Flex
      direction='column'
      asChild
    >
      <form onSubmit={onSubmit}>
        <ScrollArea scrollbars='vertical'>
          <Flex
            py='1'
            pl='1'
            mr='4'
          >
            {children}
          </Flex>
        </ScrollArea>
        <Flex
          gap='4'
          mt='4'
          mr='4'
          justify='end'
          align='center'
        >
          {onClickCancel && (
            <Button
              type='button'
              variant='ghost'
              color='gray'
              size='2'
              radius='full'
              onClick={onClickCancel}
            >
              {cancelText}
            </Button>
          )}
          {onClickSubmit && (
            <Button
              variant='outline'
              highContrast
              color='gray'
              size='2'
              radius='full'
              onClick={onClickSubmit}
              disabled={submitDisabled}
            >
              {submitText}
            </Button>
          )}
        </Flex>
      </form>
    </Flex>
  );
}

Form.propTypes = {
  onClickCancel: PropTypes.func,
  onClickSubmit: PropTypes.func,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  submitDisabled: PropTypes.bool,
};

export default Form;
